import { useLicenseFeatureAvailability } from 'utils/hooks/useLicenseFeatureAvailability';

export const useLicenseHasValidAim = (): boolean =>
  useLicenseFeatureAvailability().aim;
